export default __webpack_public_path__ + "static/media/img_introduce_benefit_1.8862a25c.png";